import React from 'react'
import WizardStepIndicator from '@Components/WizardFlow/WizardStepIndicator'
import './index.scss'
import WizardFlowStep from '@Components/WizardFlow/wizard-flow-step'

interface WizardStepIndicatorsProps {
    currentIndex: number
    steps: Array<Pick<WizardFlowStep, 'stepIndicator'>>
}

const WizardStepIndicators = ({ steps, currentIndex }: WizardStepIndicatorsProps) => (
    <div className="wizard-step-indicator-row">
        {steps.map(({ stepIndicator }, index) => (
            <WizardStepIndicator
                key={`${stepIndicator.label}-${index}`}
                index={index}
                currentIndex={currentIndex}
                stepIndicator={stepIndicator}
            />
        ))}
    </div>
)

export default WizardStepIndicators
